import { Component, Input, output, ChangeDetectionStrategy } from "@angular/core";
import { IonIcon } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

/** Page buttons of a paginated list, used on a <nav class="pager"> */
@Component({
    selector: "nav[appPager]",
    templateUrl: "./pager.component.html",
    styleUrls: ["./pager.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon, TranslatePipe],
})
export class PagerComponent {
  @Input() currentPage: number = 1;
  @Input() pageCount: number = 1;
  /** Pages to show, null is a gap between two pages */
  @Input() listPageEntry: Array<number> = [];

  /** Emits the page clicked by the user */
  readonly pageClick = output<number>();
}
